import Typography from '@mui/material/Typography';
import { useGoalById } from 'features/goals';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { EmptyChart as EmptyChartIcon } from 'shared/assets/icons';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { useOpenGoalMetricsForm } from 'shared/contexts/goal-metrics-form';

import * as Styled from './empty-chart.style';

export type EmptyChartProps = {
  compact?: boolean;
};

export const EmptyChart: React.FC<EmptyChartProps> = ({ compact }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const goal = useGoalById(id);

  const openMetricsForm = useOpenGoalMetricsForm();
  const onSelectMetric = () => {
    if (goal) {
      openMetricsForm(goal);
    }
  };

  return (
    <Styled.Container
      $isUneditable={!!goal?.frozenAt || !!goal?.archivedAt}
      $compact={!!compact}
    >
      {!compact && (
        <Styled.ImageContainer>
          <EmptyChartIcon />
        </Styled.ImageContainer>
      )}

      <Styled.Content>
        <Typography variant="h6" component="h3">
          {t('pages.goal-detail.progress.empty.title')}
        </Typography>
        {!compact && (
          <Styled.Description>
            {t('pages.goal-detail.progress.empty.description')}
          </Styled.Description>
        )}
      </Styled.Content>

      <Styled.Interactions>
        <Button
          variant={Variants.Contained}
          size={Sizes.Medium}
          color={Colors.Primary}
          onClick={
            goal?.frozenAt || goal?.archivedAt ? undefined : onSelectMetric
          }
        >
          {t('pages.goal-detail.progress.empty.button')}
        </Button>
      </Styled.Interactions>
    </Styled.Container>
  );
};
